// Use navigation events so downloads, PATCH actions and remote filters keep
// their normal behavior. Loading feedback never blocks interaction.
export function initializeNavigationLoading(doc = document, win = window) {
  let loading = false
  let request = null

  const paint = visible => {
    doc.documentElement.classList.toggle("navigation-loading", visible)
    const content = doc.getElementById("mainContent")
    if (content) {
      if (visible) content.setAttribute("aria-busy", "true")
      else content.removeAttribute("aria-busy")
    }
    const status = doc.getElementById("navigation-loading-status")
    if (status) status.textContent = visible ? status.dataset.loadingText : ""
  }
  const finish = () => {
    loading = false
    request = null
    paint(false)
  }
  const begin = () => {
    loading = Boolean(doc.getElementById("navigation-loading-status"))
    request = null
    paint(loading)
  }

  doc.addEventListener("turbolinks:visit", begin)
  doc.addEventListener("click", event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    const link = event.target.closest("a[href]")
    if (!link || link.hasAttribute("download") || link.hasAttribute("data-method") || link.getAttribute("data-remote") === "true") return
    if (link.target && link.target !== "_self") return
    const url = new URL(link.href, win.location.href)
    if (url.origin !== win.location.origin || !/^https?:$/.test(url.protocol)) return
    if (url.pathname === win.location.pathname && url.search === win.location.search) return
    // Downloads do not replace the document, so they must not leave feedback on.
    const extension = url.pathname.match(/\.[^/.]+$/)
    if (extension && !/^\.html?$/i.test(extension[0])) return
    if (url.searchParams.has("format") && !/^html?$/i.test(url.searchParams.get("format"))) return
    // Native full-page links also need feedback. Let confirmation handlers and
    // Turbolinks finish first so cancelled clicks do not leave a stuck loader.
    Promise.resolve().then(() => { if (!event.defaultPrevented) begin() })
  })
  doc.addEventListener("submit", event => {
    const form = event.target
    if (form.getAttribute("data-remote") === "true" || (form.target && form.target !== "_self")) return
    const url = new URL(form.action, win.location.href)
    if (url.origin !== win.location.origin || !/^https?:$/.test(url.protocol)) return
    if (/\.(pdf|csv|xlsx?|zip)$/i.test(url.pathname)) return
    if (url.searchParams.has("format") && !/^html?$/i.test(url.searchParams.get("format"))) return
    Promise.resolve().then(() => { if (!event.defaultPrevented) begin() })
  })
  // Existing client-side form validation calls this when it cancels submission.
  win.hidePageLoader = finish
  doc.addEventListener("turbolinks:request-start", event => {
    if (loading) request = event.data.xhr
  })
  doc.addEventListener("turbolinks:request-end", event => {
    const xhr = event.data.xhr
    if (xhr === request && (xhr.status === 0 || xhr.status >= 400)) finish()
  })
  // Keep cached snapshots clean, then restore feedback on a preview while
  // the navigation's actual response is still being fetched.
  doc.addEventListener("turbolinks:before-cache", () => paint(false))
  doc.addEventListener("turbolinks:render", () => paint(loading))
  doc.addEventListener("turbolinks:load", finish)
  win.addEventListener("pageshow", finish)
  win.addEventListener("pagehide", finish)
}

initializeNavigationLoading()
